import type { ComponentChildren, JSX } from "preact";
import { classNames } from "@gss/common/classNames";

interface Props {
    className?: string;
    small?: boolean;
    children: ComponentChildren;
}

export function ButtonGroup({
    className,
    small,
    children,
}: Props): JSX.Element {
    return (
        <div
            role="group"
            className={classNames(
                "btn-group",
                small && "btn-group-sm",
                className,
            )}
        >
            {children}
        </div>
    );
}
